module.exports = __webpack_public_path__ + "img/bgk.edcfed91.png";